export default __webpack_public_path__ + "static/Maitake-green-3d8f90e922da761622ee66d11235c317.svg";